import InitialiseSentry from './sentry';

const Initialise = () => {
  InitialiseSentry();
};

export default Initialise;
